import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDialog } from '../../models/dialog.inteface';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
})
export class AlertDialogComponent {
  // parameters are optional
  title: string | undefined;
  headingText: string | undefined;
  bodyText: string | undefined;
  footerText: string | undefined;
  btnOk: string | undefined;
  crossIcon: boolean | undefined;

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: IDialog
  ) {
    this.headingText = data?.headingText;
    this.title = data?.title;
    this.bodyText = data?.bodyText;
    this.footerText = data?.footerText;
    this.btnOk = data?.btnOk;
    this.crossIcon = data?.crossIcon ?? true;
  }

  /**
   * @description close dialog box with true statement
   * @returns void
   */
  acceptDialog(): void {
    this.dialogRef.close(true);
  }

  /**
   * @description close dialog box with false statement
   * @returns void
   */
  rejectDialog(): void {
    this.dialogRef.close(false);
  }
}
